import { useEffect, useState } from 'react';
import { PreviewAdminChangelogItemAPI } from '../../../../api/AdminAPI';

const EMPTY = { loading: false, error: null, html: '' };

/**
 * useItemEmailPreview
 *
 * HTML do e-mail com uma novidade só (admin/changelog/preview.php, item_id), como destaque
 * ou na lista. Recarrega quando o item ou o modo mudam; enabled=false não busca.
 *
 * @param {{ itemId: number|null, highlight: boolean, enabled: boolean }} options
 */
function useItemEmailPreview({ itemId, highlight, enabled }) {
  const [state, setState] = useState(EMPTY);

  useEffect(() => {
    if (!enabled || !itemId) return undefined;
    let active = true;
    setState({ ...EMPTY, loading: true });
    PreviewAdminChangelogItemAPI(itemId, highlight, (response) => {
      if (!active) return;
      if (!response || response.success === false) {
        setState({ ...EMPTY, error: response?.error || 'Não foi possível montar a prévia.' });
        return;
      }
      setState({ ...EMPTY, html: response.html || '' });
    });
    return () => { active = false; };
  }, [itemId, highlight, enabled]);

  return state;
}

export default useItemEmailPreview;
